import React from "react";
import { get } from 'lodash'

// Use d3 to have dragging work, so we'll retire this react version for now.
import { useD3 } from "d3blackbox";
import renderers from './d3Renderers';
import { LAYOUTS } from '../constants';

// Use react if performance is important?
// import { BasicTreeReact } from '../components/BasicTreeD3';
// <ReactTree hierarchyData={hierarchyData} width={treeWidth}/>

// import useDimensions from "react-use-dimensions";
import { TREE_HORIZONTAL_PADDING } from '../constants';

// In future, could refactor further, so that the "position" and "rendering" engines are separate, but this is OK for now.
const rendererMap = {
  [LAYOUTS.default]: renderers.basic,
  [LAYOUTS.traditional]: renderers.traditional,
  [LAYOUTS.horizontalTree]: renderers.horizontalTree,
  [LAYOUTS.cola]: renderers.cola,
}

// Permit you to pass in params if needed // Use switch-case?
// Can add special args for special renderers
const getRenderer = (layoutType) => {
  return get(rendererMap, layoutType, renderers.basic);
}

export const BasicTree = ({ x, y, width, height, hierarchyData, layoutType }) => {
  const treeWidth = width - TREE_HORIZONTAL_PADDING;

  const renderer = getRenderer(layoutType);
  const refAnchor = useD3(anchor => renderer(anchor, hierarchyData, treeWidth));

  return (
    <svg width={width} height={height} className="treeContainer" >
      <g transform={`translate(${x}, ${y})`} ref={refAnchor}>

      </g>
    </svg>
  );
};

export default BasicTree;
